<template>
  <!-- Navbar -->
  <header class="new-navbar logged" :class="{ open : open }" ref="header">
    <div class="mask" v-if="showMask"></div>

    <div class="new-navbar__container">
      <button class="new-navbar__hamburger" @click="openSidebar">
        <ion-icon name="menu" />
      </button>

      <h1>
        <a class="new-navbar__brand" href="/painel" title="Melhor Envio">
          <svg v-if="$options.static.isSandbox" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100.49 50" enable-background="new 0 0 226.7715 104.2209" xml:space="preserve" style="fill: #0063c1">
            <defs></defs><title>Sandbox</title><g><g><path d="M88.34,27.85v1.59A1.59,1.59,0,0,0,86.75,31v4.92H85.17V31a3.17,3.17,0,0,1,3.17-3.17"/><path d="M51,27.85a3.16,3.16,0,0,0-2.38,1.08A3.17,3.17,0,0,0,43.07,31v4.92h1.59V31a1.59,1.59,0,0,1,3.18,0v4.92h1.58V31a1.59,1.59,0,0,1,3.18,0v4.92h1.58V31A3.17,3.17,0,0,0,51,27.85"/><path d="M67.53,35.94V34.35a1.59,1.59,0,0,1-1.59-1.58v-9H64.35v9a3.17,3.17,0,0,0,3.18,3.17"/><path d="M71.76,27.85a3.08,3.08,0,0,0-1.59.43V23.82H68.58V35.94h1.59V31a1.59,1.59,0,0,1,3.18,0v4.92h1.58V31a3.17,3.17,0,0,0-3.17-3.17"/><path d="M63.21,31.12a4,4,0,0,0-7.89,0,4.07,4.07,0,0,0-.08.79,4.17,4.17,0,0,0,.08.8,4,4,0,0,0,7.19,1.6l-1.28-1A2.44,2.44,0,0,1,57,32.71h6.25a3.5,3.5,0,0,0,.08-.8,3.42,3.42,0,0,0-.08-.79m-3.94-1.65a2.44,2.44,0,0,1,2.31,1.65H57a2.44,2.44,0,0,1,2.31-1.65"/><path d="M80.06,27.85a4,4,0,1,0,4,4,4,4,0,0,0-4-4m0,6.5a2.46,2.46,0,1,1,2.46-2.46,2.46,2.46,0,0,1-2.46,2.46"/><rect x="85.1" y="37.6" width="1.59" height="8.05"/><path d="M67.46,40.85a4,4,0,0,0-7.85,0,4.15,4.15,0,0,0-.08.79,4.26,4.26,0,0,0,.08.8A4,4,0,0,0,66.76,44l-1.27-.93a2.43,2.43,0,0,1-4.25-.65h6.22a4.26,4.26,0,0,0,.08-.8,4.15,4.15,0,0,0-.08-.79m-3.93-1.64a2.44,2.44,0,0,1,2.3,1.64H61.24a2.43,2.43,0,0,1,2.29-1.64"/><path d="M71.76,37.56a3.18,3.18,0,0,0-3.18,3.17v4.92h1.59V40.73a1.59,1.59,0,0,1,3.18,0v4.92h1.58V40.73a3.17,3.17,0,0,0-3.17-3.17"/><path d="M91.79,37.56a4,4,0,1,0,4,4,4,4,0,0,0-4-4m0,6.5a2.46,2.46,0,1,1,2.46-2.46,2.46,2.46,0,0,1-2.46,2.46"/><polygon points="82.36 37.66 80.06 43.42 77.77 37.66 76.02 37.66 79.35 45.65 80.78 45.65 84.11 37.66 82.36 37.66"/><path style="fill:#e1b140;" d="M100.06,37.44h0a2.54,2.54,0,0,0-.5-1.33h0C98.7,35,97.31,34.88,96,34.85A6.91,6.91,0,0,0,97.47,31a3.85,3.85,0,0,0-1-2.87,3,3,0,0,0-.88-.6,2.43,2.43,0,0,0-1-.22,2.58,2.58,0,0,0-1.92.77,3.54,3.54,0,0,0-.85,1.74v0h0A3.16,3.16,0,0,1,91.24,31l-.38.5-.12.14,0,0-.09.11L90.5,32a12.24,12.24,0,0,1-1.08,1.1h0c-.41.37-.85.75-1.24,1.07v1.79s1.58-1.17,2.23-1.77a12.94,12.94,0,0,0,1.23-1.25l0-.05.09-.1.14-.17.12-.15.51-.69a3.87,3.87,0,0,0,.63-1.29c0-.09,0-.18.07-.27a2.3,2.3,0,0,1,.46-1.06,1.53,1.53,0,0,1,.23-.15,1.62,1.62,0,0,1,.92-.1,1.33,1.33,0,0,1,.59.31A2.4,2.4,0,0,1,96,31h0a6,6,0,0,1-1.33,3.24l-.06.1a4.21,4.21,0,0,0-.56.89l-.43,1,1,.08a5,5,0,0,0,.54,0c.17,0,.33,0,.49,0h0c1.16,0,2.15,0,2.63.66a1.1,1.1,0,0,1,.22.56,2.24,2.24,0,0,1-.11.86,3.21,3.21,0,0,0-.14,1.72,2.48,2.48,0,0,1,0,.77h0a2.54,2.54,0,0,1-.5,1.09,2.77,2.77,0,0,0-.31.54v0a2.3,2.3,0,0,0-.12.74,2.8,2.8,0,0,1-.21.84,2.93,2.93,0,0,1-.39.69,2.8,2.8,0,0,1-.44.46l0,0a1.93,1.93,0,0,0-.46.48l0,0,0,.07a7.37,7.37,0,0,1-1.36,1.73,3.57,3.57,0,0,1-1.42.7,4.24,4.24,0,0,1-.46.1,8.49,8.49,0,0,1-1.09.1,15.57,15.57,0,0,1-3.74-.46h0a18.48,18.48,0,0,0-2.5-.44H59.65a.12.12,0,1,0,0,.23L85.11,49.1a18.14,18.14,0,0,1,2.27.4,16.9,16.9,0,0,0,4.09.5,10.68,10.68,0,0,0,1.29-.11h0c.21,0,.59-.13.9-.21a3.78,3.78,0,0,0,1-.44A6.65,6.65,0,0,0,97,46.77l.09-.12a.73.73,0,0,1,.16-.16,3.79,3.79,0,0,0,1.06-1.22,3.57,3.57,0,0,0,.58-2,1,1,0,0,1,0-.25,1.74,1.74,0,0,1,.11-.18,3.92,3.92,0,0,0,.77-1.76,3.63,3.63,0,0,0,0-1.23v0a1.91,1.91,0,0,1,.07-1h0a3.45,3.45,0,0,0,.2-1.46"/><path d="M9.62,9a1,1,0,0,1-.33.36.88.88,0,0,1-.45.1,1.47,1.47,0,0,1-.58-.12L7.63,9.1a5.41,5.41,0,0,0-.75-.27,3.5,3.5,0,0,0-1-.12A2,2,0,0,0,4.73,9a1,1,0,0,0-.42.82.8.8,0,0,0,.27.63,2.26,2.26,0,0,0,.72.44,10.43,10.43,0,0,0,1,.37c.38.11.76.24,1.16.38a10.59,10.59,0,0,1,1.16.49,4.44,4.44,0,0,1,1,.7,2.89,2.89,0,0,1,.71,1,3.43,3.43,0,0,1,.27,1.42,4.76,4.76,0,0,1-.36,1.87,4,4,0,0,1-1.1,1.47,5,5,0,0,1-1.8,1,8.09,8.09,0,0,1-2.47.35,7.28,7.28,0,0,1-1.39-.14,8.35,8.35,0,0,1-1.35-.35A7.76,7.76,0,0,1,1,18.88,5.13,5.13,0,0,1,0,18.21l1-1.5a1.42,1.42,0,0,1,.4-.41A1.16,1.16,0,0,1,2,16.15a1.24,1.24,0,0,1,.64.16l.61.34A6.3,6.3,0,0,0,4,17a3.43,3.43,0,0,0,1.11.16,3,3,0,0,0,.8-.1,1.55,1.55,0,0,0,.53-.27,1,1,0,0,0,.29-.38A1.12,1.12,0,0,0,6.81,16a.9.9,0,0,0-.27-.67,2.68,2.68,0,0,0-.73-.45,8.56,8.56,0,0,0-1-.36c-.38-.1-.77-.23-1.16-.37a8.51,8.51,0,0,1-1.16-.51,3.46,3.46,0,0,1-1-.75,3.51,3.51,0,0,1-.73-1.11,4.2,4.2,0,0,1-.27-1.59A4.19,4.19,0,0,1,.78,8.5a3.85,3.85,0,0,1,1-1.37,4.87,4.87,0,0,1,1.68-.94,7.35,7.35,0,0,1,2.37-.35A7.53,7.53,0,0,1,7.27,6a7.17,7.17,0,0,1,1.29.37,6,6,0,0,1,1.1.56,5.29,5.29,0,0,1,.89.7Z"/><path d="M22.27,19.69a2,2,0,0,1-.87-.16,1.22,1.22,0,0,1-.49-.66l-.29-.75a12,12,0,0,1-1,.76,5.63,5.63,0,0,1-1,.56,4.38,4.38,0,0,1-1.08.34,6.13,6.13,0,0,1-1.26.12,5.62,5.62,0,0,1-1.7-.25,3.5,3.5,0,0,1-1.3-.72,3.13,3.13,0,0,1-.82-1.18,4.31,4.31,0,0,1-.29-1.63,3.52,3.52,0,0,1,.37-1.49,3.7,3.7,0,0,1,1.28-1.39,8,8,0,0,1,2.44-1.05,15.06,15.06,0,0,1,3.88-.42v-.58a2.54,2.54,0,0,0-.49-1.75,1.81,1.81,0,0,0-1.4-.54,3.64,3.64,0,0,0-1.19.16,5.19,5.19,0,0,0-.82.36c-.24.13-.47.24-.7.35a1.88,1.88,0,0,1-.82.16A1.17,1.17,0,0,1,14,9.72a1.4,1.4,0,0,1-.47-.5l-.74-1.28a8.19,8.19,0,0,1,2.75-1.62,9.42,9.42,0,0,1,3.22-.53,5.83,5.83,0,0,1,2.23.4A4.92,4.92,0,0,1,22.72,7.3,4.82,4.82,0,0,1,23.77,9a6,6,0,0,1,.37,2.15v8.53ZM17.59,17.2A3.12,3.12,0,0,0,19,16.92a4,4,0,0,0,1.2-.89V14.16a11,11,0,0,0-2,.16,5,5,0,0,0-1.25.4,1.54,1.54,0,0,0-.64.54,1.32,1.32,0,0,0-.18.67,1.13,1.13,0,0,0,.39,1A1.82,1.82,0,0,0,17.59,17.2Z"/><path d="M27,19.69V6.05h2.53a1.17,1.17,0,0,1,.64.17.92.92,0,0,1,.36.51l.24.79a10.41,10.41,0,0,1,.81-.68,4.53,4.53,0,0,1,.9-.53,5.52,5.52,0,0,1,1-.35,5.8,5.8,0,0,1,1.22-.12,4.71,4.71,0,0,1,2,.39A4,4,0,0,1,38.2,7.3,4.68,4.68,0,0,1,39.09,9a6.81,6.81,0,0,1,.3,2.07v8.67H35.32V11a2.42,2.42,0,0,0-.46-1.56A1.67,1.67,0,0,0,33.5,8.9a2.91,2.91,0,0,0-1.26.29,4.77,4.77,0,0,0-1.13.78v9.72Z"/><path d="M51.86,19.69a1.1,1.1,0,0,1-.64-.18.89.89,0,0,1-.36-.51l-.31-1a9,9,0,0,1-.86.79,5.11,5.11,0,0,1-1,.61,4.87,4.87,0,0,1-1.11.4,5.89,5.89,0,0,1-1.3.14,4.13,4.13,0,0,1-2-.48,4.44,4.44,0,0,1-1.57-1.37,7,7,0,0,1-1-2.19,10.58,10.58,0,0,1-.37-2.95,9.22,9.22,0,0,1,.42-2.83A7,7,0,0,1,43,7.82a5.47,5.47,0,0,1,1.85-1.5,5.33,5.33,0,0,1,2.38-.53A4.5,4.5,0,0,1,49,6.1a5.23,5.23,0,0,1,1.32.8V0h4.08V19.69Zm-4.13-2.92a3.35,3.35,0,0,0,.81-.09,3.21,3.21,0,0,0,.66-.24,2.85,2.85,0,0,0,.58-.4,5.6,5.6,0,0,0,.53-.55V9.7a2.64,2.64,0,0,0-1-.71,3,3,0,0,0-1.12-.21,2.4,2.4,0,0,0-1,.23,2.13,2.13,0,0,0-.82.71A3.86,3.86,0,0,0,45.77,11a8,8,0,0,0-.19,1.9,9.32,9.32,0,0,0,.15,1.82,3.8,3.8,0,0,0,.44,1.19,1.75,1.75,0,0,0,.68.65A2,2,0,0,0,47.73,16.77Z"/><path d="M57.54,19.69V0h4.08V7.5a6.13,6.13,0,0,1,1.73-1.21,5.3,5.3,0,0,1,2.26-.45,4.3,4.3,0,0,1,2,.46,4.54,4.54,0,0,1,1.56,1.35,6.73,6.73,0,0,1,1,2.17,10.53,10.53,0,0,1,.38,2.94,9,9,0,0,1-.43,2.84,7.16,7.16,0,0,1-1.19,2.26,5.57,5.57,0,0,1-1.85,1.5,5.16,5.16,0,0,1-2.37.54,4.46,4.46,0,0,1-1.08-.12,3.65,3.65,0,0,1-.89-.34,3.73,3.73,0,0,1-.73-.52,6.77,6.77,0,0,1-.65-.66l-.15.69a.89.89,0,0,1-.33.58,1.24,1.24,0,0,1-.64.16ZM64.19,8.9a3.32,3.32,0,0,0-.8.09,2.8,2.8,0,0,0-.67.24,2.85,2.85,0,0,0-.58.4,5.72,5.72,0,0,0-.52.56V16a2.47,2.47,0,0,0,1,.71,3.06,3.06,0,0,0,1.13.21,2.43,2.43,0,0,0,1-.23,2,2,0,0,0,.82-.71,3.89,3.89,0,0,0,.54-1.28,7.65,7.65,0,0,0,.2-1.92,8.53,8.53,0,0,0-.16-1.82,3.57,3.57,0,0,0-.44-1.19,1.73,1.73,0,0,0-.67-.65A2,2,0,0,0,64.19,8.9Z"/><path d="M78.87,5.84a8,8,0,0,1,2.83.48,6.08,6.08,0,0,1,3.6,3.6,7.94,7.94,0,0,1,.51,2.91,8,8,0,0,1-.51,2.94A6.3,6.3,0,0,1,83.89,18a6.38,6.38,0,0,1-2.19,1.4,7.79,7.79,0,0,1-2.83.5A7.9,7.9,0,0,1,76,19.4,6.56,6.56,0,0,1,73.81,18a6.34,6.34,0,0,1-1.43-2.23,8,8,0,0,1-.51-2.94,7.94,7.94,0,0,1,.51-2.91,6.3,6.3,0,0,1,1.43-2.2A6.41,6.41,0,0,1,76,6.32,8.12,8.12,0,0,1,78.87,5.84Zm0,11a2.31,2.31,0,0,0,2.07-1,5.52,5.52,0,0,0,.66-3,5.48,5.48,0,0,0-.66-3,2.31,2.31,0,0,0-2.07-1,2.38,2.38,0,0,0-2.12,1,5.39,5.39,0,0,0-.67,3,5.43,5.43,0,0,0,.67,3A2.38,2.38,0,0,0,78.87,16.87Z"/><path d="M90.52,12.64,86.13,6.05h3.92a1.42,1.42,0,0,1,.63.11,1,1,0,0,1,.36.38l2.44,4a3.71,3.71,0,0,1,.19-.46c.08-.15.17-.3.27-.47l1.73-3a1.27,1.27,0,0,1,.39-.43,1,1,0,0,1,.51-.12h3.73l-4.39,6.4,4.58,7.24H96.57a1,1,0,0,1-.7-.22,1.73,1.73,0,0,1-.43-.5L93,14.79a2.6,2.6,0,0,1-.15.42,2.56,2.56,0,0,1-.2.37l-2,3.39a1.65,1.65,0,0,1-.42.5,1,1,0,0,1-.66.22H85.94Z"/></g></g>
          </svg>
          <img v-else class="icon" src="/images/svg/melhor-envio-blue.svg" alt="Logo Melhor Envio" />
        </a>
      </h1>

      <div class="new-navbar__content">
        <ul class="new-navbar__list new-navbar__list--info">
          <li class="new-navbar__item">
            <MEBadge
              variant="danger"
              :show-badge="hasChangelog"
              overlap
            >
              <a
                class="button-unbox button-unbox--primary button-unbox--alt button-unbox--compact"
                href="https://menv.io/novidades"
                target="_blank"
                rel="noopener noreferrer"
                title="Novidades"
                @click="updateLastVisitedArticleId"
              >
                <span class="button-unbox__content">
                  <span class="button-unbox__icon">
                    <ion-icon class="ion-icon" :name="newsIconName" />
                  </span>
                  <span class="button-unbox__text">Novidades</span>
                </span>
              </a>
            </MEBadge>
          </li>
          <li class="new-navbar__item">
            <a class="new-navbar__balance" :href="$sanitizeUrl($options.static.INTERNAL_LINKS.WALLET.HOME)">
              <span v-if="accountLimit && !hasBlockedLimit">
                <strong>Limite Disponível: {{ beautifyNumberToBRL(userBalance) }}</strong>
              </span>
              <span v-else-if="hasBlockedLimit">
                <strong>Limite Bloqueado</strong>
              </span>
              <span v-else>
                Saldo: <strong>{{ beautifyNumberToBRL(userBalance) }}</strong>
              </span>
            </a>
          </li>
        </ul>
        <ul class="new-navbar__list new-navbar__list--links">
          <li class="new-navbar__item">
            <a :href="$sanitizeUrl($options.static.INTERNAL_LINKS.CALCULATOR)" class="new-navbar__item__link">
              <ion-icon class="icon icon-calculator" name="calculator-outline" />
            </a>
          </li>
          <li class="new-navbar__item">
            <a href="#" @click.prevent="openNotifyMenu()" class="new-navbar__item__link">
              <MEBadge
                variant="danger"
                :show-badge="hasNotifications"
                overlap
              >
                <ion-icon class="icon" :name="notificationsIconName" />
              </MEBadge>
            </a>
            <transition name="notification-menu">
              <div v-show="openNotify" class="new-notifications">
                <div class="new-notifications__header">
                  <h3 class="new-notifications__title">Notificações</h3>
                  <a
                    href="#"
                    class="new-notifications__mark-all"
                    @click.prevent="checkReadAll"
                  >
                    Marcar tudo como lido ({{notificationUnReadCount}})
                  </a>
                </div>
                <ul class="new-notifications__list">
                  <li
                    v-for="notification in notifications"
                    :key="notification.id"
                    class="new-notifications__list-item"
                  >
                    <div
                      class="new-notifications__item-link"
                      @click="redirectToNotification(notification)"
                    >
                      <div class="new-notifications__item-info">
                        <MEInfoBlock>
                          <template #content>
                            <h3 class="text-highlight" :class="{ 'notification-read': notification.read_at }">{{ notification.title }}</h3>
                            <p class="text-small text-neutral-clear" v-html="notification.message"></p>
                          </template>
                        </MEInfoBlock>
                      </div>
                      <div class="new-notifications__item-time">
                        {{ timeFromNow(notification.created_at) }}
                      </div>
                    </div>
                  </li>
                </ul>
                <a
                  :href="$sanitizeUrl($options.static.INTERNAL_LINKS.NOTIFICATIONS)"
                  class="new-notifications__see-more"
                >
                  Ver mais
                </a>
              </div>
            </transition>
          </li>
          <li class="new-navbar__item">
            <a href="/carrinho" class="new-navbar__item__link">
              <MEBadge
                :content="totalCartCount"
                :show-badge="cartCount > 0"
                overlap
              >
                <ion-icon class="icon" name="cart-outline" />
              </MEBadge>
            </a>
          </li>
        </ul>

        <ul class="new-navbar__list new-navbar__list--profile">
          <li class="new-navbar__item" @click="$refs.VerificationStampModal.open()">
            <button class="button-no-style flex items-center" aria-label="selo de verificação de conta">
              <verification-stamp
                @userVerificationStatus="userVerificationStatus = $event"
              ></verification-stamp>
              </button>
          </li>
          <li class="new-navbar__item">
            <a
              href="#"
              class="new-navbar__context-menu-trigger"
              :class="{'new-navbar__context-menu-trigger--open' : openUser}"
              @click.prevent="toggleUserMenu"
            >
              <MEAvatar :image="userThumbnail" :name="userName" />
              <ion-icon class="chevron" name='chevron-down-outline' />
            </a>
            <div class="new-navbar__context-menu-dropdown">
              <div class="new-navbar__context-menu-links">
                <a
                  :href="$sanitizeUrl($options.static.INTERNAL_LINKS.NOTIFICATIONS)"
                  class="new-navbar__context-menu-link-item new-navbar__context-menu-link-item--mobile"
                >
                  <ion-icon class="icon" name='notifications-outline' />
                  <span>Notificações</span>
                </a>
                <a
                  href="https://menv.io/novidades"
                  target="_blank"
                  rel="noopener noreferer"
                  class="new-navbar__context-menu-link-item new-navbar__context-menu-link-item--mobile"
                >
                  <ion-icon class="icon" name='sparkles' />
                  <span>Novidades</span>
                </a>
                <a
                  href="/painel/gerenciar/perfil"
                  class="new-navbar__context-menu-link-item"
                >
                  <ion-icon class="icon" name='person-outline' />
                  <span>Perfil</span>
                </a>
                <a
                  :href="$sanitizeUrl($options.static.INTERNAL_LINKS.HELP)"
                  class="new-navbar__context-menu-link-item"
                >
                  <ion-icon class="icon" name='help-circle-outline' />
                  <span>Ajuda</span>
                </a>
                <a
                  href="https://melhorenvio.com.br/blog"
                  target="_blank"
                  rel="noopener noreferer"
                  class="new-navbar__context-menu-link-item"
                >
                  <ion-icon class="icon" name='newspaper-outline' />
                  <span>Blog</span>
                </a>

                <hr class="new-navbar__context-menu-link-divider" />

                <a
                  v-if="!disableButton"
                  :href="$sanitizeUrl(navActionLink)"
                  class="new-navbar__context-menu-link-item"
                >
                  <ion-icon class="icon" name='hand-left-outline' />
                  <span>Administrativo</span>
                </a>
                <a
                  href="#"
                  class="new-navbar__context-menu-link-item"
                  @click.prevent="logout"
                >
                  <ion-icon class="icon" name='log-out-outline' />
                  <span>Sair</span>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <verification-stamp-modal
      ref='VerificationStampModal'
      :userVerificationStatus='userVerificationStatus'
    ></verification-stamp-modal>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import './../libs/cheats.original.js';
import date from 'commons/js/formatters/Date';
import Broadcast from '../Broadcast';
import Logo from './assets/img/logo.svg';

import UserThumbnail from 'commons/js/components/atoms/UserThumbnail';
import VerificationStamp from 'commons/js/components/atoms/VerificationStamp';
import VerificationStampModal from 'commons/js/components/atoms/VerificationStampModal';
import MEBadge from 'commons/js/components/ME/MEBadge/MEBadge';
import MEAvatar from 'commons/js/components/ME/MEAvatar/MEAvatar';
import MEInfoBlock from 'commons/js/components/ME/MEInfoBlock/MEInfoBlock';
import { beautifyNumberToBRL } from 'commons/js/formatters/Currency';
import { INTERNAL_LINKS } from 'commons/js/enums/links';

export default {
  components: {
    UserThumbnail,
    VerificationStamp,
    VerificationStampModal,
    MEBadge,
    MEAvatar,
    MEInfoBlock
  },

  props: {
    name: {
      type: String,
      required: false
    },
    lastname: {
      type: String,
      required: false
    },
    thumbnail: {
      type: String,
      required: false
    },
    balance: {
      type: String,
      required: false
    },
    accountLimit: {
      type: String,
      required: false
    },
    hasBlockedLimit: {
      type: String,
      required: false
    },
    disableButton: {
      type: String,
      required: false
    },
    actionLabel: {
      type: String,
      required: false
    },
    actionLink: {
      type: String,
      required: false
    },
    status: {
      type: String,
      required: false
    },
    limitAction: {
      type: String,
      required: false
    },
    postPaid: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      open : false,
      openUser: false,
      openNotify: false,
      userName: '',
      userThumbnail: '',
      userBalance: 0,
      notificationUnReadCount: 0,
      notifications: [],
      cartCount: 0,
      showMask: false,
      modalCalculator: false,
      showMenu: false,
      navActionLabel: 'Painel de controle',
      navActionLink: '/painel',
      logo: Logo,

      lastArticleId: null,
      lastVisitedArticleId: null,
      userVerificationStatus: '',
    }
  },
  computed: {
    ...mapGetters('general', ['sidebarOpen']),

    totalCartCount() {
      return (this.cartCount > 99)
        ? "99+"
        : this.cartCount
    },

    bellCount() {
      return this.notificationUnReadCount < 100 ? this.notificationUnReadCount : '99+';
    },

    seeMoreCount() {
      const unreadDropdown = this.notifications.filter((notification) => {
        return notification.read_at === null;
      });

      const notificationCount = this.notificationUnReadCount - unreadDropdown.length;

      if (notificationCount < 0) {
        return 0;
      }

      return notificationCount;
    },

    hasChangelog() {
      return this.lastArticleId !== this.lastVisitedArticleId;
    },

    newsIconName() {
      return this.hasChangelog ? 'sparkles' : 'sparkles-outline';
    },

    hasNotifications() {
      return +this.notificationUnReadCount > 0;
    },

    notificationsIconName() {
      return this.hasNotifications ? 'notifications' : 'notifications-outline';
    }
  },

  static: {
    INTERNAL_LINKS,
    isSandbox: MEConfig.get('app.env') === 'sandbox',
  },

  methods: {
    beautifyNumberToBRL,

    ...mapActions('general', ['changeSidebarStatus']),

    timeFromNow(value) {
      if (!value) {
        return 'Agora';
      }

      return date.getAbbreviatedRelativeTime(date.getLocalDate(value));
    },
    fingerprint() {
      if (MEConfig.get('admin', false)) {
        return;
      }
      if (window.requestIdleCallback) {
        requestIdleCallback(() => {
          new Fingerprint2().get((hash) => {
            this.logger(hash);
          });
        });
      } else {
        setTimeout(() => {
          new Fingerprint2().get((hash) => {
            this.logger(hash);
          });
        }, 500);
      }
    },
    openLink(link, action, target = '_self') {
      try {
        gtag('event', 'click', {
          'event_category': 'navbar-limit-action',
          'event_label': action
        });
      } catch (error) {
        console.log('gtag error:', error);
      }
      window.open(link, target);
    },
    logger(hash) {
      if (localStorage && MEConfig.get('user.id')) {
        const key = 'FP:' + MEConfig.get('user.id') + ':' + hash;
        if (!localStorage.getItem(key)) {
          axios.get('/fp/' + hash).then(() => {
            localStorage.setItem(key, '1');
          });
        }
      } else {
        axios.get('/fp/' + hash);
      }
    },
    floatCalc() {
      try {
        gtag('event', 'Calculadora', { event_category: 'Calculadora', event_label: 'Modal', event_action: 'click'});
      } catch (e) {

      }

      this.showModal('modalCalculator');
    },
    updateNotifications() {
      axios.head('/api/v2/me/notifications?read=false&per_page=1000').then((response) => {
        if (response.headers.hasOwnProperty('x-total-count')) {
          this.notificationUnReadCount = response.headers['x-total-count'];
        }
      });
      axios.get('/api/v2/me/notifications?per_page=3').then((response) => {
        let notifications = response.data.data;
        if (notifications.length) {
          this.notifications = notifications.filter((e) => e.data.title).map((notification) => {
            return {
              id: notification.id,
              title: notification.data.title,
              message: notification.data.message,
              link: notification.data.link,
              created_at: notification.created_at,
              read_at:  notification.read_at
            };
          });
        }
      });
    },
    updateCart() {
      this.cartCount = 0;
      axios.head('/api/v2/me/cart?per_page=1000').then((response) => {
        if (response.headers.hasOwnProperty('x-total-count')) {
          this.cartCount = parseInt(response.headers['x-total-count']);
        }
      });
    },
    pushNotification(notification) {
      this.notifications.unshift(notification);
    },
    incrementCart() {
      this.cartCount++;
    },
    decrementCart() {
      if (this.cartCount > 0) {
        this.cartCount--;
      }
    },
    clearCart() {
      this.cartCount = 0;
    },

    updateUser() {
      axios.get('/api/v2/me').then((response) => {
        if (response.data) {
          if (response.data.firstname) {
            this.userName = response.data.firstname;

            if (response.data.lastname) {
              this.userName = `${response.data.firstname} ${response.data.lastname}`;
            }
          }
          this.userThumbnail = response.data.thumbnail;
        }
      });
    },
    updateBalance() {
      axios.get('/api/v2/me/balance').then((response) => {
        if (response.data.hasOwnProperty('balance')) {
          this.userBalance = response.data.balance;
        }
      });
    },
    toggleMenu() {
      this.open = !this.open;
      if (!this.open)
        return;
      setTimeout(() => {
        document.body.addEventListener('click', this.closeMenu, false);
      });
    },
    closeMenu() {
      this.open = false;
      document.body.removeEventListener('click', this.closeMenu);
    },
    toggleUserMenu() {
      this.openNotify = false;
      this.openUser = !this.openUser;
      if (!this.openUser)
        return;
      setTimeout(() => {
        document.body.addEventListener('click', this.closeUserMenu, false);
      });
    },
    closeUserMenu() {
      this.openUser = false;
      document.body.removeEventListener('click', this.closeUserMenu);
    },
    openNotifyMenu() {
      this.openUser = false;
      this.openNotify = !this.openNotify;
      if (!this.openNotify) {
        return;
      }

      let vm = this;
      let listener = function(e) {
        if (!(e.target.id == "notification-dropdown" || $(e.target).parents("#notification-dropdown").length)) {
          vm.openNotify = false;
          document.querySelector('.siteWrapper').removeEventListener('click', listener, false);
        }
      }

      setTimeout(() => {
        document.querySelector('.siteWrapper').addEventListener(
          "click",
          listener,
          false
        )
      });
    },
    logout() {
      axios.post('/logout')
        .then(() => {
          try {
            if (window.octadesk && window.octadesk.chat){
              window.octadesk.chat.clearSession();
            }
          } catch (error) {
            console.error(error);
          } finally {
            location.href = '/login';
          }
        });
    },

    checkReadAll() {
      axios.put('/api/v2/me/notifications/read-all').then(() => {
        this.updateNotifications();
      });
    },

    showModal(modal) {
      this[modal] = true;
      this.showMask = true;

      let self = this;
      window.addEventListener('keyup', function keyPress(e) {
        let key = e.which || e.keyCode;

        if (key === 27)
          self.hideAllModals();

        window.removeEventListener('keyup', keyPress);
      });
    },

    hideModal(modal) {
      this[modal] = false;
      this.showMask = false;
    },

    hideAllModals() {
      this.showMask = false;
      this.modalCalculator = false;
    },

    async redirectToNotification(notification) {
      await this.markAsRead(notification.id, notification.read_at);

      let hasLink = this.findUrl(notification.message);

      if (hasLink) {
        window.open(hasLink, '_blank');

        return;
      }

      if (notification.link) {
        const {url, target} = notification.link;

        window.open(url, target || '_self');

        return;
      }

      window.location.href = INTERNAL_LINKS.NOTIFICATIONS;
    },

    findUrl(value) {
      const url = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_\+.~#?&\/\/=]*)/u;

      let found = value.match(url);

      if (found) {
        return found[0];
      }
    },

    async markAsRead(id, read_at) {
      if (read_at) {
        return;
      }

      try {
        const {data: notificationData} = await axios.put(`/api/v2/me/notifications/${id}`);
        if (notificationData) {
          let notificationRead = this.notifications.find(
            notification => notification.id === id
          )
          if (notificationRead) {
            notificationRead.read_at = notificationData.read_at;
            this.notificationUnReadCount--;
          }
        }
      } catch (error) {
        /*
         * WIP - Estamos trabalhando em uma solução global
         * para o tratamento de erros.
        */
        console.error(error);
      }
    },

    async getLastArticleId() {
      try {
        const {data: {id}} = await axios.get('/api/v2/news/id-latest-news-article');

        this.lastArticleId = id;
      } catch (error) {
        console.error(error);
      }
    },

    async getLastVisitedArticleId() {
      try {
        const {data: {id_latest_news_article}} = await axios.get('/api/v2/me/preferences/id_latest_news_article');

        this.lastVisitedArticleId = id_latest_news_article;
      } catch (error) {
        console.error(error);
      }
    },

    async updateLastVisitedArticleId() {
      if (this.hasChangelog) {
        await axios.put('/api/v2/me/preferences', {
          id_latest_news_article: this.lastArticleId
        });

        this.lastVisitedArticleId = this.lastArticleId;
      }
    },

    openSidebar() {
      this.changeSidebarStatus(true);
    }
  },

  mounted() {
    this.$root.$headerMenu = this.$refs.header;

    const channel = Broadcast.user(MEConfig.get('user.id'));

    channel.notification((notification) => {
      this.notificationUnReadCount++;

      if (this.notifications.length >= 3) {
        this.notifications.pop();
      }

      this.notifications.unshift(notification);
    });
  },

  created() {
    this.userName = this.name ? this.name : '';
    this.userBalance = this.balance ? this.balance : '';
    this.userThumbnail = this.thumbnail;
    if (this.actionLabel) {
      this.navActionLabel = this.actionLabel;
    }
    if (this.actionLink) {
      this.navActionLink = this.actionLink;
    }
    if (this.name && this.lastname) {
      this.userName = `${this.name} ${this.lastname}`;
    }
    this.getLastArticleId();
    this.getLastVisitedArticleId();
    this.updateNotifications();
    this.updateCart();
    window['$me_nav'] = (method) => {
      switch (method) {
        case 'update-user':
          this.updateUser();
          break;
        case 'update-balance':
          this.updateBalance();
          break;
        case 'update-notifications':
          this.updateNotifications();
          break;
        case 'update-cart':
          this.updateCart();
          break;
        case 'push-notification':
          this.pushNotification.apply(this, arguments.slice(1, arguments.length));
          break;
        case 'increment-cart':
          this.incrementCart();
          break;
        case 'decrement-cart':
          this.decrementCart();
          break;
        case 'clear-cart':
          this.clearCart();
          break;
      }
    };
    if (['production', 'sandbox'].indexOf(MEConfig.get('app.env')) === -1) {
      try {
        window['$me.helpers']();
      } catch (e) {}
    }

    this.fingerprint();
  }
}
</script>

<style lang="stylus" scoped>
.changelog-link
  position relative
.changelog-badge
  position absolute
  top -16px
  right 10px
  width 18px
  height 18px
  background-color #E53E49
  border-radius 100%

  @media screen and (max-width 1400px)
    width 16px
    height 16px
    top -14px

  @media screen and (max-width 1100px)
    top -12px
    right 0px
    width 14px
    height 14px

  @media screen and (max-width 940px)
    top 0px
    right -20px
    width 16px
    height 16px

.notification-read::before
  content '● '
  color #3598DC
</style>
